import  secureLocalStorage  from  "react-secure-storage";

export const setDebateStatus = async (key)=>{
    let debateStatus = secureLocalStorage.getItem(key);
    if(debateStatus){
        return debateStatus
    }
    else{
        secureLocalStorage.setItem(key,true);
        const debateStatus = secureLocalStorage.getItem (key)
        return debateStatus
        
    }

}